module.exports = __webpack_public_path__ + "img/70.8e5c2798.png";